export { default as KlarnaCreditPromotionBadge } from './KlarnaCreditPromotionBadge'



// WEBPACK FOOTER //
// ./src/components/klarnaCreditPromotionBadge/index.js